import React, { useEffect, useState } from 'react'
import { editclassProps } from './edit-interface'
import { Alert, Button, Form, Input, Modal } from 'antd'
import { editClass } from '../../../../../api/class/class';
import { openNotificationWithIcon } from '../../../../../utils/helper';

const Editclass = ({ open, closeModal, classId, language, classDetails }: editclassProps) => {
	const [form] = Form.useForm();

	const [stageOneData, setStageOneData] = useState({
		name: "",
		description: "",
	})
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<any>(null)
	const [errors, setErrors] = useState({
		name: "",
		description: "",
	})

	useEffect(() => {
		setStageOneData((prevState) => ({
			...prevState,
			...classDetails
		}))
		form.setFieldsValue({
			...classDetails
		})

		// eslint-disable-next-line
	}, [classDetails])


	const onFinish = async (values: any) => {
		try {
			setLoading(true)
			setError(null)
			setErrors(prevState => ({
				...prevState,
				name: "",
				description: "",
			}))

			const res = await editClass({ ...values }, classId)

			const { message } = res.data

			openNotificationWithIcon("success", "Edit Class", message || 'Class edited successfully')
			setLoading(false)
			closeModal(true)

		} catch (error: any) {
			setLoading(false)
			const otherErrors: any[] = []
			if (error?.response) {
				if (error?.response?.data?.errors) {
					const resError = error?.response?.data?.errors

					Object.entries(resError).forEach(([key, value]) => {
						if (Object.keys(errors).includes(key)) {
							setErrors(prevState => ({
								...prevState,
								[key]: value
							}))
						} else {
							otherErrors.push(value)
						}
					})

					if (otherErrors.length > 0) {
						const errorList = otherErrors.map((element: any, index) => {
							return <li key={`error-list-${index}`}>{element}</li>
						});
						setError(errorList)
					}

				} else {
					setError(error?.response?.data?.message || 'Something went wrong')
				}
			} else {
				setError('Something went wrong')
			}
		}
	}

	return (
		<div>
			<Modal
				closable={false}
				open={open}
				onOk={() => {
					if (!loading) {
						closeModal()
					}
				}}
				onCancel={() => {
					if (!loading) {
						closeModal()
					}
				}}
				footer={null}
				width={'38rem'}
				className='white-bg-modal'
			>
				<div>
					<div className='flex border-b border-appcolorgreyfour pb-[0.75rem] justify-between items-center'>
						<h1 className='text-[22px] leading-[110%] font-semibold text-appcolorgrey mb-[-1rem]'>Edit Class</h1>
						<div className='rounded-full bg-appcolorgreyfive custom-box-shadow-five p-[0.9rem] w-fit cursor-pointer'
							onClick={() => {
								if (!loading) {
									closeModal()
								}
							}}
						>
							<img src="/img/vectors/modalclose.svg" alt="" />
						</div>
					</div>

					<div className='mt-[2rem]'>
						{
							error !== null ?
								<div className='mb-4'>
									<Alert message={error} type="error" />
								</div>
								: null
						}


						<Form
							layout="vertical"
							onFinish={onFinish}
							form={form}
							initialValues={{
								...stageOneData
							}}
						>
							<Form.Item
								label="Name"
								name="name"
								rules={[{ required: true, message: 'Input is required' }]}
								validateStatus={errors?.name.length > 0 ? 'error' : undefined}
								help={errors?.name.length > 0 ? errors?.name : undefined}
							>
								<Input
									onChange={() => {
										setErrors(prevState => ({
											...prevState,
											name: '',
										}))
									}}
									placeholder="Enter a name for your class"
								/>
							</Form.Item>

							<Form.Item
								label="Language"
							>
								<Input
									value={language}
									disabled
								/>
							</Form.Item>

							<Form.Item
								label="Description"
								name="description"
								rules={[{ required: true, message: 'Input is required' }]}
								validateStatus={errors?.description.length > 0 ? 'error' : undefined}
								help={errors?.description.length > 0 ? errors?.description : undefined}
							>
								<Input
									onChange={() => {
										setErrors(prevState => ({
											...prevState,
											description: '',
										}))
									}}
									placeholder="Enter a description for your class"
								/>
							</Form.Item>

							<div className='mt-[2.5rem] flex justify-end'>
								<Button
									onClick={() => {
										if (!loading) {
											closeModal()
										}
									}}
									style={{
										color: '#200E32 !important'
									}}
									disabled={loading}
									className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>

									Cancel
								</Button>

								<Button
									disabled={loading}
									className='custom-primary-two-btn smaller-padding'
									loading={loading}
									htmlType='submit'
								>
									Continue
								</Button>
							</div>
						</Form>
					</div>

				</div>
			</Modal>
		</div>
	)
}

export default Editclass